import http from "../../../http-commonv2";

const outboundGeneral = (data) => {
  return http.post(`/api/v2/stats/outbound/general`, data);
};

const distributionByAgent = (data) => {
  return http.post(`/api/v2/stats/outbound/distributionByAgent`, data);
};

const timeAveragesPerAgent = (data) => {
  return http.post(`/api/v2/stats/outbound/timeAveragesPerAgent`, data);
};

const timelineDistribution = (data) => {
  return http.post(`/api/v2/stats/outbound/timelineDistribution`, data);
};
const timelineAverages = (data) => {
  return http.post(`/api/v2/stats/outbound/timelineAverages`, data);
};
const agentDistributionByQueue = (data) => {
  return http.post(`/api/v2/stats/outbound/agentDistributionByQueue`, data);
};

const agentDistributionByAttempts = (data) => {
  return http.post(`/api/v2/stats/outbound/agentDistributionByAttempts`, data);
};

const StatsService = {
  outboundGeneral,
  distributionByAgent,
  timeAveragesPerAgent,
  timelineDistribution,
  timelineAverages,
  agentDistributionByQueue,
  agentDistributionByAttempts,
};

export default StatsService;
